;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var product = window.product;
	var $product;

	$doc.ready(function() {
		$product = $('#product');

		$('.field, .textarea').on('keydown keyup', function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};

		}).each(function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};
			
		});

		// Mobile Menu

		$('.btn-menu').on('click', function (event) {
			$(this).toggleClass('active').closest('body').toggleClass('header-visible'); 		    
			event.preventDefault();
		});

		
			// Product Popup
			$('.link-popup').magnificPopup({
				type: "image",
				gallery: {
					enabled: true
				}
			});

		

		
			$productSlider = $('.slider-product .owl-carousel');
			// Slider Gallery
			$productSlider.owlCarousel({
				items: 1,
				loop: true,
				
				    dots: false,
				
				
					animateOut: 'fadeOut',
					mouseDrag: false,
					pullDrag: false,
					freeDrag: false
				
			});

			
				$('.product-thumbnails li a').on('click', function(event) {
					event.preventDefault();
					var $this = $(this);
					$productSlider.trigger('to.owl.carousel', $this.parent().index());
					$this.parent().addClass('active').siblings().removeClass('active');
				})
			
		

		$('.addresses .cancel').on('click', function(event) {
			var $section = $(this).closest('.accordion-section');

			$section.find('.accordion-body').slideUp();
			
			event.preventDefault();
		});

		$('.btn-new-adress, .form-add-address .cancel').on('click', function(event) {

			$('.form-add-address').slideToggle();

			event.preventDefault();
		});

		// Variants listing logic - [Radio/Select]
		
			if ($product.length) {
				new Shopify.OptionSelectors('product-select', {
					product: window.product,
					onVariantSelected: function(variant, selector) {

						if (variant.available) {
							var price = Shopify.formatMoney(variant.price, Shopify.money_format);
							var compare_at_price = Shopify.formatMoney(variant.compare_at_price, Shopify.money_format);

							if (variant.compare_at_price > variant.price) {
								price = '<span class="compare-price">' + compare_at_price + '</span>' + price;
							};

						} else {
							price = 'Sold Out';
						};

						$('.product-price', $product).html(price).toggleClass('out-of-stock', !variant.available);

						if (variant.featured_image) {
							var imageSrc = variant.featured_image.src,
								image = imageSrc.split('/');
								image =  image[image.length - 1];

							$('[data-image*="'+ image +'"]').trigger('change.image');
						}

					},
					enableHistoryState: true
				});

				if (product && product.variants.length == 1 && product.variants[0].title.indexOf('Default') == 0 ) {
					$('.selector-wrapper').hide();
				};
			};
		


	});

	Shopify.CustomerAddress = {
		toggleForm: function(address_id) {
			var $form = $('#address_form_' + address_id),
				$section = $form.closest('.accordion-section');

			$section.find('.accordion-body').slideDown();

			$section.siblings().find('.accordion-body').stop(true, true).slideUp();

			return false;
		},

		destroy: function(id, confirm_msg) {
			if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
				Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
			}
		}
	}
})(jQuery, window, document);
